import { Mail, MapPin, Phone, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import AnimatedGrid from "./AnimatedGrid";

const ContactSection = () => {
  return (
    <>
      {/* Contact area with animated grid */}
      <section id="contact" className="py-16 md:py-24 relative section-light overflow-hidden">
        <AnimatedGrid />

        <div className="container mx-auto px-4 sm:px-6 lg:px-12 relative z-10">
          <div className="grid lg:grid-cols-5 gap-10 lg:gap-16">
            {/* Left */}
            <div className="lg:col-span-3">
              <span className="section-label">Contactos</span>
              <h2 className="section-heading mb-6 md:mb-8">
                Vamos criar<br />
                algo <span className="text-accent">extraordinário</span>?
              </h2>
              <p className="text-muted-foreground text-base md:text-lg leading-relaxed max-w-lg">
                Estamos prontos para transformar a sua visão em realidade.
                Entre em contacto com a nossa equipa.
              </p>
            </div>

            {/* Right */}
            <div className="lg:col-span-2 space-y-4 sm:space-y-6 lg:pt-12">
              <div className="glass-card p-4 sm:p-6 flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-accent/10 flex items-center justify-center shrink-0">
                  <Mail size={16} className="text-accent" />
                </div>
                <div>
                  <p className="text-xs text-muted-foreground tracking-wider uppercase mb-1">Email</p>
                  <a href="mailto:geral@evoke.pt" className="text-foreground font-medium hover:text-accent transition-colors text-sm">
                    geral@evoke.pt
                  </a>
                </div>
              </div>

              <div className="glass-card p-4 sm:p-6 flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-accent/10 flex items-center justify-center shrink-0">
                  <Phone size={16} className="text-accent" />
                </div>
                <div>
                  <p className="text-xs text-muted-foreground tracking-wider uppercase mb-1">Telefone</p>
                  <a href="tel:+351234099539" className="text-foreground font-medium hover:text-accent transition-colors text-sm">
                    +351 234 099 539
                  </a>
                </div>
              </div>

              <div className="glass-card p-4 sm:p-6 flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-accent/10 flex items-center justify-center shrink-0">
                  <MapPin size={16} className="text-accent" />
                </div>
                <div>
                  <p className="text-xs text-muted-foreground tracking-wider uppercase mb-1">Localização</p>
                  <p className="text-foreground font-medium text-sm">
                    TABpark — Zona Industrial da Taboeira<br />
                    Lote 27, Fração H1<br />
                    3800-055 Aveiro
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer — sem grid animada */}
      <footer className="py-8 md:py-10 section-light">
        <div className="container mx-auto px-4 sm:px-6 lg:px-12">
          <div className="pt-4 border-t border-border flex flex-col items-center gap-4 md:gap-3">
            <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-6">
              <p className="text-xs sm:text-sm text-muted-foreground">
                © {new Date().getFullYear()} EVK — Thinkers & Makers
              </p>
              <div className="flex gap-4 text-xs text-muted-foreground">
                <Link to="/termos" className="hover:text-foreground transition-colors">Termos</Link>
                <Link to="/privacidade" className="hover:text-foreground transition-colors">Privacidade</Link>
              </div>
            </div>
            <div className="flex flex-wrap justify-center gap-x-6 gap-y-2">
              {[
                { label: "OWL Creative", url: "https://owlcreative.pt" },
                { label: "EVOKE IT", url: "https://evoke.pt" },
                { label: "Brand n' Play", url: "https://brandnplay.com" },
                { label: "Index Rerum", url: "https://indexrerum.com" },
              ].map((link) => (
                <a
                  key={link.label}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1 text-xs sm:text-sm text-muted-foreground hover:text-foreground transition-colors"
                >
                  {link.label}
                  <ArrowUpRight size={12} />
                </a>
              ))}
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default ContactSection;
